// ─── Template : SÉLECTEUR DE DURÉE [−] n [＋] [Mois↻] ─────────────
// Décidé par Cédric le 13/08, applicable à toute la suite : partout où l'on
// choisit une durée, on veut le compteur ± ET un bouton d'unité TOURNANT —
// un appui bascule mois ↔ année. Ce qui remplace :
//   • la rangée `[12] [Mois] [Année] [OK]` (quatre commandes pour une valeur),
//   • le stepper qui passait tout seul en années au-delà de 12, sans le dire.
//
//   <SelecteurDuree valeur={{ n: 6, unite: 'mois' }} onChange={setH} />
//   <SelecteurDuree valeur={p} onChange={setP} avecTout maxMois={120} />
//
// ⚠️ Le bouton d'unité ne convertit PAS le nombre : 12 mois devient 12 années.
// Convertir serait plus « intelligent » et beaucoup moins prévisible — le
// bouton ne fait qu'une chose, et elle est visible.
// Les règles vivent dans `services/duree.js`, module pur et testé.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { useT } from '../i18n/LangueContext';
import Stepper from './Stepper';
import { ANNEE, TOUT, basculerUnite, normaliser, pas } from '../services/duree';

export default function SelecteurDuree({
  valeur, onChange, maxMois = 120, avecTout = false, min = 1, style,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  const d = normaliser(valeur, min);
  const cest = d === TOUT;
  const opts = { maxMois, avecTout, min };

  // « Tout » n'a pas d'unité : le bouton perdrait son sens, on l'efface au
  // lieu de l'afficher inerte — un bouton qui ne fait rien est un piège.
  const bouton = cest ? null : (
    <TouchableOpacity style={s.unite} activeOpacity={0.7}
      onPress={() => onChange?.(basculerUnite(d))}
      accessibilityRole="button"
      accessibilityLabel={t(d.unite === ANNEE ? 'commun.basculerMois' : 'commun.basculerAnnee')}>
      <Text style={s.uniteTxt}>{t(d.unite === ANNEE ? 'commun.annee' : 'commun.mois')}</Text>
      <Text style={s.rot}>⇄</Text>
    </TouchableOpacity>
  );

  return (
    <Stepper style={style}
      valeur={cest ? t('commun.tout') : d.n}
      onMoins={() => onChange?.(pas(d, -1, opts))}
      onPlus={() => onChange?.(pas(d, 1, opts))}
      apres={bouton} />
  );
}

const makeStyles = (UI) => StyleSheet.create({
  unite: { flexDirection: 'row', alignItems: 'center', gap: 6, marginLeft: 6, paddingHorizontal: 14, paddingVertical: 7, borderRadius: 11, borderWidth: 1, borderColor: UI.accent, backgroundColor: UI.card },
  uniteTxt: { fontSize: 14.5, fontWeight: '800', color: UI.accent },
  rot: { fontSize: 12, color: UI.faint, fontWeight: '700' },
});
